import styled from 'styled-components';

/**
 * Prefer FormLabel for labelling form inputs
 */
const Label = styled.div`
  font-size: 12px;
  color: #68718d;
  margin-bottom: 4px;
`;

export default Label;
